import React from 'react';
import AutocompleteInput from './AutocompleteInput';

export default class AutocompleteMultiInput extends React.Component {

    onRemoveSelection(selection) {
        this.props.update(this.props.name, this.props.selection.filter(s => s !== selection));
    }

    render() {
        return (
            <div>
                <AutocompleteInput multi={true} {...this.props} />
                {this.props.selection.map(selectionKey => {
                    const selection = this.props.options[this.props.options.map(o => o.key).indexOf(selectionKey)];
                    return selection ? <div key={selectionKey} className="chip name-chip">
                        <span>{selection.displayvalue || selection.value}</span>
                        <i className="material-icons delete-chip" onClick={this.onRemoveSelection.bind(this, selectionKey)}>close</i>
                    </div> : null;
                })}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/commonComponents/util/AutocompleteMultiInput.jsx